import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NvIconButtonModule } from 'Src/nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { NvIconModule } from 'Src/nvps-libraries/design/nv-icon/nv-icon.module';
import { NvMatTooltipModule } from '../../../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ListDisplayModule } from '../list-display.module';
import { ListDisplayCareerPath } from './list-display-career-path/list-display-career-path.component';
import { ListDisplayCollegePath } from './list-display-college-path/list-display-college-path.component';

@NgModule({
  declarations: [ListDisplayCollegePath, ListDisplayCareerPath],
  imports: [
    CommonModule,
    ListDisplayModule,
    NvMatTooltipModule,
    MatMenuModule,
    MatIconModule,
    NvIconButtonModule,
    NvIconModule,
  ],
  exports: [ListDisplayCollegePath, ListDisplayCareerPath],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ListDisplayPathModule {
  /** */
}
